/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";
import { UpdateRoleMutationVariables } from "../../../types/graphql";

import "./styles.css";

interface IPermissions {
    fields: UpdateRoleMutationVariables;
    setFields: React.Dispatch<React.SetStateAction<UpdateRoleMutationVariables>>;
    changeableField: string;
    radio1Title: string;
    radio2Title: string;
    disabled?: boolean;
}

const RadioBtnsComponent: React.FC<IPermissions> = ({
    fields,
    setFields,
    changeableField,
    radio1Title,
    radio2Title,
    disabled,
}) => {
    useEffect(() => {
        if (disabled) {
            setFields({
                ...fields,
                permissions: {
                    ...fields?.permissions,
                    [changeableField]: false,
                },
            });
        }
    }, [disabled]);

    return (
        <div className="radio-btns_mainContainer">
            <div className="radio-btns_btnContainer">
                <label>
                    <input
                        type="radio"
                        name={changeableField}
                        value={3}
                        checked={fields?.permissions[changeableField] && !disabled}
                        onChange={() =>
                            setFields({
                                ...fields,
                                permissions: {
                                    ...fields?.permissions,
                                    [changeableField]: !fields?.permissions[changeableField],
                                },
                            })
                        }
                        disabled={disabled}
                    />
                    <div className="radiobox"></div>
                    <span>{radio1Title}</span>
                </label>
            </div>
            <div className="radio-btns_btnContainer">
                <label>
                    <input
                        type="radio"
                        name={changeableField}
                        value={1}
                        checked={!fields?.permissions[changeableField] && !disabled}
                        onChange={() =>
                            setFields({
                                ...fields,
                                permissions: {
                                    ...fields?.permissions,
                                    [changeableField]: !fields?.permissions[changeableField],
                                },
                            })
                        }
                        disabled={disabled}
                    />
                    <div className="radiobox"></div>
                    <span>{radio2Title}</span>
                </label>
            </div>
        </div>
    );
};

export default RadioBtnsComponent;
